import React from "react";
import { Phone, MessageCircle, Mail, MapPin, Link as LinkIcon } from "lucide-react";

const TYPE_META = {
    phone: { icon: Phone, label: "Telefon", href: (v) => `tel:${v.replace(/[^+\d]/g, "")}` },
    whatsapp: { icon: MessageCircle, label: "WhatsApp", href: (v) => `https://wa.me/${v.replace(/[^\d]/g, "")}` },
    email: { icon: Mail, label: "E-posta", href: (v) => `mailto:${v}` },
    address: { icon: MapPin, label: "Adres", href: null },
    link: { icon: LinkIcon, label: "Bağlantı", href: (v) => (/^https?:\/\//.test(v) ? v : `https://${v}`) },
};

const ExtraContacts = ({ items = [], compact = false, title = "Ek İletişim Kanalları" }) => {
    const list = (items || []).filter((c) => c && (c.value || "").trim());
    if (list.length === 0) return null;

    return (
        <div data-testid="extra-contacts">
            {!compact && (
                <div className="text-xs uppercase tracking-[0.3em] text-gold mb-3">{title}</div>
            )}
            <div className={`grid ${compact ? "sm:grid-cols-2" : "sm:grid-cols-2 lg:grid-cols-3"} gap-3`}>
                {list.map((c, i) => {
                    const meta = TYPE_META[c.type] || TYPE_META.phone;
                    const Icon = meta.icon;
                    const href = meta.href ? meta.href(c.value) : null;
                    const Tag = href ? "a" : "div";
                    const linkProps = href ? { href, target: c.type === "address" ? undefined : "_blank", rel: "noreferrer" } : {};
                    return (
                        <Tag
                            key={i}
                            {...linkProps}
                            className={`border border-border_green ${href ? "hover:border-gold" : ""} p-4 bg-emerald_surface flex items-start gap-3 transition-colors`}
                            data-testid={`extra-contact-${c.type || "phone"}-${i}`}
                        >
                            <Icon className="w-4 h-4 text-gold flex-shrink-0 mt-1" />
                            <div className="min-w-0">
                                <div className="text-[10px] uppercase tracking-[0.2em] text-muted_green">
                                    {(c.label || meta.label).slice(0, 60)}
                                </div>
                                <div className="text-sm break-words">{c.value}</div>
                            </div>
                        </Tag>
                    );
                })}
            </div>
        </div>
    );
};

export default ExtraContacts;
